import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  ModificationChainSerializer1sjx3ub694ze6 as ModificationChainSerializer,
  ModificationIfNotNullSerializerjulstagon91h as ModificationIfNotNullSerializer,
  ModificationAssignSerializer20mjm937imzn9 as ModificationAssignSerializer,
  ModificationCoerceAtMostSerializer2e37y5d7g8cw6 as ModificationCoerceAtMostSerializer,
  ModificationCoerceAtLeastSerializer289b07fpxwnn2 as ModificationCoerceAtLeastSerializer,
  ModificationIncrementSerializer2uue65jxbk7cl as ModificationIncrementSerializer,
  ModificationMultiplySerializer2zqnd64egc8a0 as ModificationMultiplySerializer,
  ModificationAppendStringSerializer_getInstanceu0cqqe9pm1k as ModificationAppendStringSerializer_getInstance,
  ModificationAppendRawStringSerializer1syi2fot31cc3 as ModificationAppendRawStringSerializer,
  ModificationListAppendSerializer26of7wz5yd6a0 as ModificationListAppendSerializer,
  ModificationListRemoveSerializer1jblinhoeqtc7 as ModificationListRemoveSerializer,
  ModificationListRemoveInstancesSerializerq3lg7pkejk91 as ModificationListRemoveInstancesSerializer,
  ModificationListDropFirstSerializer11ld8x0re3l6n as ModificationListDropFirstSerializer,
  ModificationListDropLastSerializer6haifsne6eac as ModificationListDropLastSerializer,
  ModificationSerializer36sautdazlmsc as ModificationSerializer,
  ModificationSetAppendSerializer25l37c29egm40 as ModificationSetAppendSerializer,
  ModificationSetRemoveSerializer2loajeq81vlho as ModificationSetRemoveSerializer,
  ModificationSetRemoveInstancesSerializerxr9lu54tk9ad as ModificationSetRemoveInstancesSerializer,
  ModificationSetDropFirstSerializerh82esa6nfns5 as ModificationSetDropFirstSerializer,
  ModificationSetDropLastSerializer1qfw97w8jizwx as ModificationSetDropLastSerializer,
  ModificationCombineSerializer9vl8tr65gnfu as ModificationCombineSerializer,
  ModificationRemoveKeysSerializer3m9nk2caanh5o as ModificationRemoveKeysSerializer,
} from './ModificationSerialization.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  SealedTypeDiscriminator__hashCode_impl_3l9vn82rzp7wjugbfem as SealedTypeDiscriminator__hashCode_impl_3l9vn8,
} from './SealedTypeDiscriminator.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Modification$Nothing$_anonymous__h2kh1q() {
  var tmp = Nothing_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('com.lightningkite.services.database.Modification.Nothing', tmp, tmp$ret$0);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationChainSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Modification$Chain$toString$lambda(it) {
  return toString(it);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationIfNotNullSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationAssignSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationCoerceAtMostSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationCoerceAtLeastSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationIncrementSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationMultiplySerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return ModificationAppendStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationAppendRawStringSerializer())();
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationListAppendSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationListRemoveSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationListRemoveInstancesSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationListDropFirstSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationListDropLastSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Modification.ListPerElement', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_Modification_ListPerElement_$serializer_beprhr_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  if (Companion_instance_13 === VOID) {
    Companion_instance_22;
    new (Companion_13())();
  }
  return Companion_instance_13;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_ListPerElement_$serializer_soao0h_k$();
      }
      static new_com_lightningkite_services_database_Modification_ListPerElement_$serializer_soao0h_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Modification.ListPerElement', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_nxa1pb_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), value.modification_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_nxa1pb_k$(encoder, value instanceof ListPerElement() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ListPerElement().new_com_lightningkite_services_database_Modification_ListPerElement_hw4sk7_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Modification_ListPerElement_$serializer_beprhr_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Modification_ListPerElement_$serializer_soao0h_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSetAppendSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSetRemoveSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  return Companion_instance_15;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSetRemoveInstancesSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  return Companion_instance_16;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSetDropFirstSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  return Companion_instance_17;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSetDropLastSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  return Companion_instance_18;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Modification.SetPerElement', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_services_database_Modification_SetPerElement_$serializer_3q760r_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID) {
    Companion_instance_22;
    new (Companion_19())();
  }
  return Companion_instance_19;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_SetPerElement_$serializer_8l5khx_k$();
      }
      static new_com_lightningkite_services_database_Modification_SetPerElement_$serializer_8l5khx_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Modification.SetPerElement', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_h6joj1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), value.modification_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_h6joj1_k$(encoder, value instanceof SetPerElement() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SetPerElement().new_com_lightningkite_services_database_Modification_SetPerElement_pnao8d_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Modification_SetPerElement_$serializer_3q760r_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Modification_SetPerElement_$serializer_8l5khx_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationCombineSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  return Companion_instance_20;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationRemoveKeysSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_21;
function Companion_getInstance_21() {
  return Companion_instance_21;
}
var NothingClass;
function Nothing() {
  if (NothingClass === VOID) {
    class $ extends Modification() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_Nothing_woti4w_k$();
      }
      static new_com_lightningkite_services_database_Modification_Nothing_woti4w_k$() {
        Nothing_instance = null;
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        Nothing_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Modification$Nothing$_anonymous__h2kh1q);
        return $this;
      }
      toString() {
        return '';
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
      hashCode() {
        return -86611392;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Nothing()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Nothing', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: Nothing_getInstance});
    NothingClass = $;
  }
  return NothingClass;
}
var Nothing_instance;
function Nothing_getInstance() {
  if (Nothing_instance === VOID)
    Nothing().new_com_lightningkite_services_database_Modification_Nothing_woti4w_k$();
  return Nothing_instance;
}
var ChainClass;
function Chain() {
  if (ChainClass === VOID) {
    class $ extends Modification() {
      constructor(modifications) {
        return new.target.new_com_lightningkite_services_database_Modification_Chain_qdmx0f_k$(modifications);
      }
      static new_com_lightningkite_services_database_Modification_Chain_qdmx0f_k$(modifications) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.modifications_1 = modifications;
        return $this;
      }
      toString() {
        return joinToString(this.modifications_1, '; ', VOID, VOID, VOID, VOID, Modification$Chain$toString$lambda);
      }
      hashCode() {
        return hashCode(this.modifications_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Chain()))
          return false;
        if (!equals(this.modifications_1, other.modifications_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Chain', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ChainClass = $;
  }
  return ChainClass;
}
var IfNotNullClass;
function IfNotNull() {
  if (IfNotNullClass === VOID) {
    class $ extends Modification() {
      constructor(modification) {
        return new.target.new_com_lightningkite_services_database_Modification_IfNotNull_mgiwu9_k$(modification);
      }
      static new_com_lightningkite_services_database_Modification_IfNotNull_mgiwu9_k$(modification) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.modification_1 = modification;
        return $this;
      }
      toString() {
        return '?' + toString(this.modification_1);
      }
      hashCode() {
        return hashCode(this.modification_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfNotNull()))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfNotNull', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    IfNotNullClass = $;
  }
  return IfNotNullClass;
}
var IfIsTypeClass;
function IfIsType() {
  if (IfIsTypeClass === VOID) {
    class $ extends Modification() {
      constructor(discriminator, modification) {
        return new.target.new_com_lightningkite_services_database_Modification_IfIsType_v12ard_k$(discriminator, modification);
      }
      static new_com_lightningkite_services_database_Modification_IfIsType_v12ard_k$(discriminator, modification) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.discriminator_1 = discriminator;
        $this.modification_1 = modification;
        return $this;
      }
      static new_com_lightningkite_services_database_Modification_IfIsType_tcecoc_k$(serializer, modification) {
        return this.new_com_lightningkite_services_database_Modification_IfIsType_v12ard_k$(_SealedTypeDiscriminator___init__impl__jf77jn(serializer), modification);
      }
      toString() {
        return ' as? ' + _SealedTypeDiscriminator___get_serialName__impl__x46m55(this.discriminator_1) + ' ' + toString(this.modification_1);
      }
      hashCode() {
        var result = SealedTypeDiscriminator__hashCode_impl_3l9vn8(this.discriminator_1);
        result = imul(result, 31) + hashCode(this.modification_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfIsType()))
          return false;
        if (!(this.discriminator_1 === other.discriminator_1))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfIsType');
    IfIsTypeClass = $;
  }
  return IfIsTypeClass;
}
var AssignClass;
function Assign() {
  if (AssignClass === VOID) {
    class $ extends Modification() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(value);
      }
      static new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.value_1 = value;
        return $this;
      }
      toString() {
        return ' = ' + toString_0(this.value_1);
      }
      hashCode() {
        return this.value_1 == null ? 0 : hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Assign()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Assign', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    AssignClass = $;
  }
  return AssignClass;
}
var CoerceAtMostClass;
function CoerceAtMost() {
  if (CoerceAtMostClass === VOID) {
    class $ extends Modification() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Modification_CoerceAtMost_yhu95r_k$(value);
      }
      static new_com_lightningkite_services_database_Modification_CoerceAtMost_yhu95r_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.value_1 = value;
        return $this;
      }
      toString() {
        return ' = .coerceAtMost(' + toString(this.value_1) + ')';
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CoerceAtMost()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CoerceAtMost', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    CoerceAtMostClass = $;
  }
  return CoerceAtMostClass;
}
var CoerceAtLeastClass;
function CoerceAtLeast() {
  if (CoerceAtLeastClass === VOID) {
    class $ extends Modification() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Modification_CoerceAtLeast_iwc7nz_k$(value);
      }
      static new_com_lightningkite_services_database_Modification_CoerceAtLeast_iwc7nz_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.value_1 = value;
        return $this;
      }
      toString() {
        return ' = .coerceAtLeast(' + toString(this.value_1) + ')';
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CoerceAtLeast()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CoerceAtLeast', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    CoerceAtLeastClass = $;
  }
  return CoerceAtLeastClass;
}
var IncrementClass;
function Increment() {
  if (IncrementClass === VOID) {
    class $ extends Modification() {
      constructor(by) {
        return new.target.new_com_lightningkite_services_database_Modification_Increment_h5xavn_k$(by);
      }
      static new_com_lightningkite_services_database_Modification_Increment_h5xavn_k$(by) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.by_1 = by;
        return $this;
      }
      toString() {
        return ' += ' + toString(this.by_1);
      }
      hashCode() {
        return hashCode(this.by_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Increment()))
          return false;
        if (!equals(this.by_1, other.by_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Increment', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    IncrementClass = $;
  }
  return IncrementClass;
}
var MultiplyClass;
function Multiply() {
  if (MultiplyClass === VOID) {
    class $ extends Modification() {
      constructor(by) {
        return new.target.new_com_lightningkite_services_database_Modification_Multiply_oj02wu_k$(by);
      }
      static new_com_lightningkite_services_database_Modification_Multiply_oj02wu_k$(by) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.by_1 = by;
        return $this;
      }
      toString() {
        return ' *= ' + toString(this.by_1);
      }
      hashCode() {
        return hashCode(this.by_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Multiply()))
          return false;
        if (!equals(this.by_1, other.by_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Multiply', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    MultiplyClass = $;
  }
  return MultiplyClass;
}
var AppendStringClass;
function AppendString() {
  if (AppendStringClass === VOID) {
    class $ extends Modification() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Modification_AppendString_3vq13i_k$(value);
      }
      static new_com_lightningkite_services_database_Modification_AppendString_3vq13i_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.value_1 = value;
        return $this;
      }
      toString() {
        return ' += ' + this.value_1;
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AppendString()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AppendString', VOID, VOID, VOID, VOID, VOID, {0: ModificationAppendStringSerializer_getInstance});
    AppendStringClass = $;
  }
  return AppendStringClass;
}
var AppendRawStringClass;
function AppendRawString() {
  if (AppendRawStringClass === VOID) {
    class $ extends Modification() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Modification_AppendRawString_9qsesl_k$(value);
      }
      static new_com_lightningkite_services_database_Modification_AppendRawString_9qsesl_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.value_1 = value;
        return $this;
      }
      toString() {
        return ' += ' + this.value_1;
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AppendRawString()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AppendRawString', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    AppendRawStringClass = $;
  }
  return AppendRawStringClass;
}
var ListAppendClass;
function ListAppend() {
  if (ListAppendClass === VOID) {
    class $ extends Modification() {
      constructor(items) {
        return new.target.new_com_lightningkite_services_database_Modification_ListAppend_qrb1tt_k$(items);
      }
      static new_com_lightningkite_services_database_Modification_ListAppend_qrb1tt_k$(items) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.items_1 = items;
        return $this;
      }
      toString() {
        return ' += ' + toString(this.items_1);
      }
      hashCode() {
        return hashCode(this.items_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAppend()))
          return false;
        if (!equals(this.items_1, other.items_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAppend', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    ListAppendClass = $;
  }
  return ListAppendClass;
}
var ListRemoveClass;
function ListRemove() {
  if (ListRemoveClass === VOID) {
    class $ extends Modification() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Modification_ListRemove_z7k4od_k$(condition);
      }
      static new_com_lightningkite_services_database_Modification_ListRemove_z7k4od_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        return $this;
      }
      toString() {
        return '.removeAll { it.' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListRemove()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListRemove', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    ListRemoveClass = $;
  }
  return ListRemoveClass;
}
var ListRemoveInstancesClass;
function ListRemoveInstances() {
  if (ListRemoveInstancesClass === VOID) {
    class $ extends Modification() {
      constructor(items) {
        return new.target.new_com_lightningkite_services_database_Modification_ListRemoveInstances_v0avp_k$(items);
      }
      static new_com_lightningkite_services_database_Modification_ListRemoveInstances_v0avp_k$(items) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.items_1 = items;
        return $this;
      }
      toString() {
        return ' -= ' + toString(this.items_1);
      }
      hashCode() {
        return hashCode(this.items_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListRemoveInstances()))
          return false;
        if (!equals(this.items_1, other.items_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListRemoveInstances', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_10});
    ListRemoveInstancesClass = $;
  }
  return ListRemoveInstancesClass;
}
var ListDropFirstClass;
function ListDropFirst() {
  if (ListDropFirstClass === VOID) {
    class $ extends Modification() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_ListDropFirst_5x08li_k$();
      }
      static new_com_lightningkite_services_database_Modification_ListDropFirst_5x08li_k$() {
        return this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof ListDropFirst() ? other : null) == null);
      }
      toString() {
        return '.removeFirst()';
      }
    }
    initMetadataForClass($, 'ListDropFirst', $.new_com_lightningkite_services_database_Modification_ListDropFirst_5x08li_k$, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    ListDropFirstClass = $;
  }
  return ListDropFirstClass;
}
var ListDropLastClass;
function ListDropLast() {
  if (ListDropLastClass === VOID) {
    class $ extends Modification() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_ListDropLast_z6iayo_k$();
      }
      static new_com_lightningkite_services_database_Modification_ListDropLast_z6iayo_k$() {
        return this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof ListDropLast() ? other : null) == null);
      }
      toString() {
        return '.removeLast()';
      }
    }
    initMetadataForClass($, 'ListDropLast', $.new_com_lightningkite_services_database_Modification_ListDropLast_z6iayo_k$, VOID, VOID, VOID, VOID, {0: Companion_getInstance_12});
    ListDropLastClass = $;
  }
  return ListDropLastClass;
}
var ListPerElementClass;
function ListPerElement() {
  if (ListPerElementClass === VOID) {
    class $ extends Modification() {
      constructor(condition, modification) {
        return new.target.new_com_lightningkite_services_database_Modification_ListPerElement_sz0zlz_k$(condition, modification);
      }
      static new_com_lightningkite_services_database_Modification_ListPerElement_sz0zlz_k$(condition, modification) {
        Companion_getInstance_13();
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        $this.modification_1 = modification;
        return $this;
      }
      toString() {
        return '.onEach { if (it.' + toString(this.condition_1) + ') it.' + toString(this.modification_1) + ' }';
      }
      hashCode() {
        var result = this.condition_1.hashCode();
        result = imul(result, 31) + hashCode(this.modification_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListPerElement()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Modification_ListPerElement_hw4sk7_k$(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance_13();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_13().$cachedDescriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        $this.modification_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'ListPerElement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
    ListPerElementClass = $;
  }
  return ListPerElementClass;
}
var SetAppendClass;
function SetAppend() {
  if (SetAppendClass === VOID) {
    class $ extends Modification() {
      constructor(items) {
        return new.target.new_com_lightningkite_services_database_Modification_SetAppend_p0ge6d_k$(items);
      }
      static new_com_lightningkite_services_database_Modification_SetAppend_p0ge6d_k$(items) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.items_1 = items;
        return $this;
      }
      toString() {
        return ' += ' + toString(this.items_1);
      }
      hashCode() {
        return hashCode(this.items_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAppend()))
          return false;
        if (!equals(this.items_1, other.items_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAppend', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_14});
    SetAppendClass = $;
  }
  return SetAppendClass;
}
var SetRemoveClass;
function SetRemove() {
  if (SetRemoveClass === VOID) {
    class $ extends Modification() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Modification_SetRemove_zidqc7_k$(condition);
      }
      static new_com_lightningkite_services_database_Modification_SetRemove_zidqc7_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        return $this;
      }
      toString() {
        return '.removeAll { it.' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetRemove()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetRemove', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_15});
    SetRemoveClass = $;
  }
  return SetRemoveClass;
}
var SetRemoveInstancesClass;
function SetRemoveInstances() {
  if (SetRemoveInstancesClass === VOID) {
    class $ extends Modification() {
      constructor(items) {
        return new.target.new_com_lightningkite_services_database_Modification_SetRemoveInstances_7ds9nf_k$(items);
      }
      static new_com_lightningkite_services_database_Modification_SetRemoveInstances_7ds9nf_k$(items) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.items_1 = items;
        return $this;
      }
      toString() {
        return ' -= ' + toString(this.items_1);
      }
      hashCode() {
        return hashCode(this.items_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetRemoveInstances()))
          return false;
        if (!equals(this.items_1, other.items_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetRemoveInstances', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_16});
    SetRemoveInstancesClass = $;
  }
  return SetRemoveInstancesClass;
}
var SetDropFirstClass;
function SetDropFirst() {
  if (SetDropFirstClass === VOID) {
    class $ extends Modification() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_SetDropFirst_uq1ysc_k$();
      }
      static new_com_lightningkite_services_database_Modification_SetDropFirst_uq1ysc_k$() {
        return this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof SetDropFirst() ? other : null) == null);
      }
      toString() {
        return '.removeFirst()';
      }
    }
    initMetadataForClass($, 'SetDropFirst', $.new_com_lightningkite_services_database_Modification_SetDropFirst_uq1ysc_k$, VOID, VOID, VOID, VOID, {0: Companion_getInstance_17});
    SetDropFirstClass = $;
  }
  return SetDropFirstClass;
}
var SetDropLastClass;
function SetDropLast() {
  if (SetDropLastClass === VOID) {
    class $ extends Modification() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Modification_SetDropLast_g1stcm_k$();
      }
      static new_com_lightningkite_services_database_Modification_SetDropLast_g1stcm_k$() {
        return this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof SetDropLast() ? other : null) == null);
      }
      toString() {
        return '.removeLast()';
      }
    }
    initMetadataForClass($, 'SetDropLast', $.new_com_lightningkite_services_database_Modification_SetDropLast_g1stcm_k$, VOID, VOID, VOID, VOID, {0: Companion_getInstance_18});
    SetDropLastClass = $;
  }
  return SetDropLastClass;
}
var SetPerElementClass;
function SetPerElement() {
  if (SetPerElementClass === VOID) {
    class $ extends Modification() {
      constructor(condition, modification) {
        return new.target.new_com_lightningkite_services_database_Modification_SetPerElement_cniaa7_k$(condition, modification);
      }
      static new_com_lightningkite_services_database_Modification_SetPerElement_cniaa7_k$(condition, modification) {
        Companion_getInstance_19();
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        $this.modification_1 = modification;
        return $this;
      }
      toString() {
        return '.onEach { if (' + toString(this.condition_1) + ') ' + toString(this.modification_1) + ' }';
      }
      hashCode() {
        var result = this.condition_1.hashCode();
        result = imul(result, 31) + hashCode(this.modification_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetPerElement()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Modification_SetPerElement_pnao8d_k$(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_19().$cachedDescriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.condition_1 = condition;
        $this.modification_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'SetPerElement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_19});
    SetPerElementClass = $;
  }
  return SetPerElementClass;
}
var CombineClass;
function Combine() {
  if (CombineClass === VOID) {
    class $ extends Modification() {
      constructor(map) {
        return new.target.new_com_lightningkite_services_database_Modification_Combine_bmxq2k_k$(map);
      }
      static new_com_lightningkite_services_database_Modification_Combine_bmxq2k_k$(map) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.map_1 = map;
        return $this;
      }
      toString() {
        return ' += ' + toString(this.map_1);
      }
      hashCode() {
        return hashCode(this.map_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Combine()))
          return false;
        if (!equals(this.map_1, other.map_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Combine', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
    CombineClass = $;
  }
  return CombineClass;
}
var RemoveKeysClass;
function RemoveKeys() {
  if (RemoveKeysClass === VOID) {
    class $ extends Modification() {
      constructor(fields) {
        return new.target.new_com_lightningkite_services_database_Modification_RemoveKeys_5rog8r_k$(fields);
      }
      static new_com_lightningkite_services_database_Modification_RemoveKeys_5rog8r_k$(fields) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.fields_1 = fields;
        return $this;
      }
      toString() {
        return ' -= ' + toString(this.fields_1);
      }
      hashCode() {
        return hashCode(this.fields_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemoveKeys()))
          return false;
        if (!equals(this.fields_1, other.fields_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RemoveKeys', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
    RemoveKeysClass = $;
  }
  return RemoveKeysClass;
}
var OnFieldClass;
function OnField() {
  if (OnFieldClass === VOID) {
    class $ extends Modification() {
      constructor(key, modification) {
        return new.target.new_com_lightningkite_services_database_Modification_OnField_3hlyhh_k$(key, modification);
      }
      static new_com_lightningkite_services_database_Modification_OnField_3hlyhh_k$(key, modification) {
        var $this = this.new_com_lightningkite_services_database_Modification_rq66jm_k$();
        $this.key_1 = key;
        $this.modification_1 = modification;
        return $this;
      }
      toString() {
        var tmp;
        var tmp_0 = this.modification_1;
        if (tmp_0 instanceof OnField()) {
          tmp = this.key_1.get_name_woqyms_k$() + '.' + toString(this.modification_1);
        } else {
          var tmp_1 = this.modification_1;
          if (tmp_1 instanceof Chain()) {
            tmp = this.key_1.get_name_woqyms_k$() + '.let { ' + toString(this.modification_1) + ' }';
          } else {
            tmp = this.key_1.get_name_woqyms_k$() + toString(this.modification_1);
          }
        }
        return tmp;
      }
      hashCode() {
        var result = hashCode(this.key_1);
        result = imul(result, 31) + hashCode(this.modification_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnField()))
          return false;
        if (!equals(this.key_1, other.key_1))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OnField');
    OnFieldClass = $;
  }
  return OnFieldClass;
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ModificationSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_22;
function Companion_getInstance_22() {
  return Companion_instance_22;
}
var ModificationClass;
function Modification() {
  if (ModificationClass === VOID) {
    class $ {
      static new_com_lightningkite_services_database_Modification_rq66jm_k$() {
        return createThis(this);
      }
    }
    initMetadataForClass($, 'Modification', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
    ModificationClass = $;
  }
  return ModificationClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
Companion_instance_11 = new (Companion_11())();
Companion_instance_12 = new (Companion_12())();
Companion_instance_14 = new (Companion_14())();
Companion_instance_15 = new (Companion_15())();
Companion_instance_16 = new (Companion_16())();
Companion_instance_17 = new (Companion_17())();
Companion_instance_18 = new (Companion_18())();
Companion_instance_20 = new (Companion_20())();
Companion_instance_21 = new (Companion_21())();
Companion_instance_22 = new (Companion_22())();
//endregion
//region block: exports
export {
  AppendRawString as AppendRawString34ujb3ehxmc69,
  AppendString as AppendString16i0d1y6ycmfz,
  Assign as Assign2jm8flaivtcon,
  Chain as Chain19a4phelb7wvt,
  CoerceAtLeast as CoerceAtLeast2ab0yoy33rfu,
  CoerceAtMost as CoerceAtMostq5a6wez8cbc3,
  Combine as Combineenmtpkmzz4x,
  IfIsType as IfIsType2q85mbl9d19gv,
  IfNotNull as IfNotNull38wuwth0boumg,
  Increment as Increment1pfryvb4zoayz,
  ListAppend as ListAppend33qq4czoszla7,
  ListDropFirst as ListDropFirst19o4xwpphf8ln,
  ListDropLast as ListDropLastpn5v16j4rov9,
  ListPerElement as ListPerElement3otxrneyl53yk,
  ListRemoveInstances as ListRemoveInstances2ej6cwqnkecnk,
  ListRemove as ListRemove19cmtj4n1o925,
  Multiply as Multiply1xe85fphx1al8,
  Nothing as Nothing3qsizz6tw38jz,
  OnField as OnFielduegjwkreacmm,
  RemoveKeys as RemoveKeys367ctzny0wdt9,
  SetAppend as SetAppend21wbdzlb467lu,
  SetDropFirst as SetDropFirst2rqppx5fk611e,
  SetDropLast as SetDropLastow7b3ky3amx8,
  SetPerElement as SetPerElement2huwz2o9oppuj,
  SetRemoveInstances as SetRemoveInstancesjh7gkqqf27pt,
  SetRemove as SetRemove34o7bveplt00y,
  Modification as Modification18t7xkem2wa8b,
  Companion_instance_7 as Companion_instanced9y0ghw4y3f4,
  Companion_instance_6 as Companion_instance1oe56hdndwklm,
  Companion_instance_1 as Companion_instance3q5qrbb8dvim2,
  Companion_instance as Companion_instance16cifvdjsintt,
  Companion_instance_3 as Companion_instance1iw39v478z3sa,
  Companion_instance_2 as Companion_instance2xs5meuo4uk7b,
  Companion_instance_20 as Companion_instance2gc3grqkqb8ba,
  Companion_instance_22 as Companion_instance7x85vjcu6250,
  Companion_instance_0 as Companion_instance3bnzzufvyr983,
  Companion_instance_4 as Companion_instance3okjoeswc063e,
  Companion_instance_8 as Companion_instanceez0w06et8n0z,
  Companion_instance_11 as Companion_instance2ca3a70e9t58s,
  Companion_instance_12 as Companion_instancewuhi7j8dzj2n,
  Companion_getInstance_13 as Companion_getInstance7fe8bbmq9v9z,
  Companion_instance_9 as Companion_instance288oh9kic3o9e,
  Companion_instance_10 as Companion_instance1fe0vifomrwt0,
  Companion_instance_5 as Companion_instance3jp69gxf6v3e3,
  Nothing_getInstance as Nothing_getInstance1x7nejv3dwhdr,
  Companion_instance_21 as Companion_instanceh5qpv80ys58j,
  Companion_instance_14 as Companion_instancetqr20ikb6k9i,
  Companion_instance_17 as Companion_instance2dt70m4k7qloa,
  Companion_instance_18 as Companion_instance385iatw7zqcbc,
  Companion_getInstance_19 as Companion_getInstance2sdnjo9tz10if,
  Companion_instance_15 as Companion_instance1brivik930s8s,
  Companion_instance_16 as Companion_instance1skqa9ankg6k1,
};
//endregion

//# sourceMappingURL=Modification.mjs.map
